<template>
  <v-section>
    <v-data-table
      :headers="headers"
      :single-expand="true"
      :items="BusKYCData"
      :expanded.sync="expanded"
      item-key="id"
      show-expand
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>KYC</v-toolbar-title>
          <!-- <v-spacer></v-spacer>
          <v-btn depressed  color="primary" dark class="mb-2" @click="BusDialog = true">
            <v-icon small class="me-2">mdi-content-save-plus-outline</v-icon>
            Add Applicant Info
          </v-btn> -->
        </v-toolbar>
      </template>
      <template v-slot:item.full_name="{ item }">
        <div class="d-flex">
          <v-avatar size="36px" color="primary">
            <span class="white--text text-uppercase"
              >{{ item.full_name.slice(0, 2) }}
            </span>
          </v-avatar>
          <div class="ms-2">
            <p class="m-0 p-0 font-weight-bold">
              {{ item.full_name }}
            </p>
            <span class="grey--text">{{ item.applicant_type }}</span>
          </div>
        </div>
      </template>
      <template v-slot:item.id_first_page="{ item }">
        <v-avatar size="36px" @click="handleImageViewer(item.id_first_page)">
          <img
            v-if="item.id_first_page"
            alt="Avatar"
            :src="item.id_first_page"
          />
          <v-icon v-else>mdi-user</v-icon>
        </v-avatar>
      </template>
      <template v-slot:item.id_last_page="{ item }">
        <v-avatar size="36px" @click="handleImageViewer(item.id_last_page)">
          <img v-if="item.id_last_page" alt="Avatar" :src="item.id_last_page" />
          <v-icon v-else>mdi-user</v-icon>
        </v-avatar>
      </template>
      <template v-slot:item.applicant_selfy="{ item }">
        <v-avatar size="36px" @click="handleImageViewer(item.applicant_selfy)">
          <img
            v-if="item.applicant_selfy"
            alt="Avatar"
            :src="item.applicant_selfy"
          />
          <v-icon v-else>mdi-user</v-icon>
        </v-avatar>
      </template>
      <template v-slot:item.kyc_status="{ item }">
        <v-btn
          depressed
          :color="getColor(item.kyc_status)"
          block
          class="no-uppercase"
          dense
          small
          outlined
          dark
          @click="updateStatus(item)"
        >
          {{ item.kyc_status ? item.kyc_status : "Update status"
          }}<v-icon right small>mdi-content-save-edit-outline</v-icon></v-btn
        >
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <span class="text-h6 font-weight-light title-lbl"
            >Additional Info</span
          >
          <v-row class="ma-5">
            <v-col cols="12" lg="12" xs="12">
              <v-row justify="space-between">
                <v-col cols="6" lg="6" xs="6">
                  <div class="menu-sec">
                    <v-list-item
                      class="d-flex justify-content-between align-items-center"
                    >
                      <label>Application Type</label>
                      <b>{{ item.applicant_type }}</b>
                    </v-list-item>
                    <v-list-item
                      class="d-flex justify-content-between align-items-center"
                    >
                      <label>ID</label>
                      <b>{{ item.id_number }}</b>
                    </v-list-item>
                    <v-list-item
                      class="d-flex justify-content-between align-items-center"
                    >
                      <label>ID Type</label>
                      <b>{{ item.id_type && item.id_type.value }}</b>
                    </v-list-item>
                    <v-list-item
                      class="d-flex justify-content-between align-items-center"
                    >
                      <label>Full Name</label>
                      <b>{{ item.full_name }}</b>
                    </v-list-item>
                    <v-list-item
                      class="d-flex justify-content-between align-items-center"
                    >
                      <label>Date of Birth</label>
                      <b>{{ item.dob }}</b>
                    </v-list-item>
                    <v-list-item
                      class="d-flex justify-content-between align-items-center"
                    >
                      <label>Gender</label>
                      <b>{{ item.gender }}</b>
                    </v-list-item>
                    <v-list-item
                      class="d-flex justify-content-between align-items-center"
                    >
                      <label>Occupation</label>
                      <b>{{ item.occupation && item.occupation.value }}</b>
                    </v-list-item>
                  </div>
                </v-col>
                <v-col cols="6" lg="6" xs="6">
                  <div class="menu-sec">
                    <v-list-item
                      class="d-flex justify-content-between align-items-center"
                    >
                      <label>Address</label>
                      <b>{{ item.address }}</b>
                    </v-list-item>
                    <v-list-item
                      class="d-flex justify-content-between align-items-center"
                    >
                      <label>Country</label>
                      <b>{{ item.country && item.country.name }}</b>
                    </v-list-item>
                    <v-list-item
                      class="d-flex justify-content-between align-items-center"
                    >
                      <label>E-mail</label>
                      <b>{{ item.email_id }}</b>
                    </v-list-item>
                    <v-list-item
                      class="v-flex justify-content-between align-items-center"
                    >
                      <label>Phone Number</label>
                      <b>{{ item.phone_number }}</b>
                    </v-list-item>
                    <v-list-item v-if="!isMykadIdType(item.id_type)"
                      class="v-flex justify-content-between align-items-center"
                    >
                      <label>Issue Date</label>
                      <b>{{ item.id_issue_date }}</b>
                    </v-list-item>
                    <v-list-item v-if="!isMykadIdType(item.id_type)"
                      class="v-flex justify-content-between align-items-center"
                    >
                      <label>Expiry Date</label>
                      <b>{{ item.id_expiry_date }}</b>
                    </v-list-item>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </td>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn depressed outlined color="primary" small @click="editData(item)">
          Edit<v-icon small> mdi-content-save-edit-outline </v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog persistent v-model="BusDialog" max-width="1000">
      <v-card>
        <v-form ref="Addform" v-model="valid">
          <v-toolbar color="secondary" dark flat dense>
            KYC Details
            <v-spacer></v-spacer>
            <v-btn depressed icon @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Full Name
                </label>
                <v-text-field
                  v-model="editedItem.full_name"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Full Name"
                  :rules="FieldRequired('Full Name')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize"> Gender </label>
                <v-autocomplete
                  v-model="editedItem.gender"
                  :items="genderOptions"
                  item-text="text"
                  item-value="value"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Gender"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize">
                  Date Of Birth
                </label>
                <v-text-field
                  v-model="editedItem.dob"
                  class="rounded"
                  dense
                  outlined
                  type="date"
                  placeholder="Date of Birth"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize">
                  Country Of Birth
                </label>
                <v-autocomplete
                  v-model="editedItem.country_code"
                  :items="country_options"
                  item-text="text"
                  item-value="value"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Country of Birth"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Nationality
                </label>
                <v-autocomplete
                  v-model="editedItem.nationality_code"
                  :items="country_options"
                  item-text="text"
                  item-value="value"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Nationality"
                  :rules="FieldRequired('Nationality')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Occupation
                </label>
                <v-autocomplete
                  v-model="editedItem.occupation_code"
                  class="rounded"
                  :items="Occupation"
                  dense
                  outlined
                  placeholder="Occupation"
                  :rules="FieldRequired('Occupation')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize"> Address </label>
                <v-text-field
                  v-model="editedItem.address"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Address"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  ID Type
                </label>
                <v-autocomplete
                  v-model="editedItem.id_type_code"
                  :items="IDTypes"
                  class="rounded"
                  dense
                  outlined
                  placeholder="ID Type"
                  :rules="FieldRequired('ID Type')"
                ></v-autocomplete>
              </v-col>
              <v-col v-if="!isMykad" cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Issue Date
                </label>
                <v-text-field
                  v-model="editedItem.id_issue_date"
                  class="rounded"
                  dense
                  outlined
                  type="date"
                  placeholder="Issue Date"
                  :rules="FieldRequired('Issue Date')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize">
                  Issue Location
                </label>
                <v-autocomplete
                  v-model="editedItem.id_issue_country"
                  :items="country_options"
                  item-text="text"
                  item-value="value"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Issue Location"
                ></v-autocomplete>
              </v-col>
              <v-col v-if="!isMykad" cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Expire Date
                </label>
                <v-text-field
                  v-model="editedItem.id_expiry_date"
                  class="rounded"
                  dense
                  outlined
                  type="date"
                  placeholder="Expire Date"
                  :rules="FieldRequired('Expire Date')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  ID Number
                </label>
                <v-text-field
                  v-model="editedItem.id_number"
                  class="rounded"
                  dense
                  outlined
                  placeholder="ID Number"
                  :rules="FieldRequired('ID Number')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <!-- <label class="my-0 rounded labelFontsize required"> ID First Page </label>
                <v-text-field
                  v-model="editedItem.id_first_page"
                  class="rounded"
                  dense
                  outlined
                  placeholder=" ID First Page"
                  :rules="FieldRequired('ID First Page')"
                ></v-text-field> -->
                <label class="labelFontsize my-0 required"
                  >ID First Page (Image only)
                </label>
                <v-file-input
                  v-model="editedItem.id_first_page"
                  dense
                  outlined
                  ref="idfirstfile"
                  class="rounded"
                  accept="image/png, image/jpeg, image/bmp, image/bmp"
                  placeholder="ID First Page"
                  prepend-icon=""
                  :rules="fileRules"
                  @change="
                    handleFileUpload(editedItem.id_first_page, 'firstpage')
                  "
                >
                  <template v-slot:append>
                    <v-btn depressed x-small icon @click="openIdfirst">
                      <v-icon aria-hidden="false" color="primary">
                        mdi-cloud-upload
                      </v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:append-outer>
                    <v-img
                      v-if="
                        editedItem.id_first_page
                          ? editedItem.id_first_page
                          : null
                      "
                      class="mt-0 pa-0"
                      max-height="40"
                      max-width="50"
                      :src="
                        editedItem.id_first_page
                          ? editedItem.id_first_page
                          : null
                      "
                      @click="
                        handleImageViewer(
                          editedItem.id_first_page
                            ? editedItem.id_first_page
                            : null,
                        )
                      "
                    />
                  </template>
                </v-file-input>
              </v-col>
              <v-col cols="12" md="4">
                <!-- <label class="my-0 rounded labelFontsize required"> ID Last Page </label>
                <v-text-field
                  v-model="editedItem.id_last_page"
                  class="rounded"
                  dense
                  outlined
                  placeholder=" ID Last Page"
                  :rules=""
                ></v-text-field> -->
                <label class="labelFontsize my-0"
                  >ID Last Page (Image only)
                </label>
                <v-file-input
                  v-model="editedItem.id_last_page"
                  dense
                  outlined
                  ref="idlastfile"
                  class="rounded"
                  accept="image/png, image/jpeg, image/bmp, image/bmp"
                  placeholder="ID Last Page"
                  prepend-icon=""
                  @change="
                    handleFileUpload(editedItem.id_last_page, 'lastpage')
                  "
                >
                  <template v-slot:append>
                    <v-btn depressed x-small icon @click="openIdlast">
                      <v-icon aria-hidden="false" color="primary">
                        mdi-cloud-upload
                      </v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:append-outer>
                    <v-img
                      v-if="
                        editedItem.id_last_page ? editedItem.id_last_page : null
                      "
                      class="mt-0 pa-0"
                      max-height="40"
                      max-width="50"
                      :src="
                        editedItem.id_last_page ? editedItem.id_last_page : null
                      "
                      @click="
                        handleImageViewer(
                          editedItem.id_last_page
                            ? editedItem.id_last_page
                            : null,
                        )
                      "
                    />
                  </template>
                </v-file-input>
              </v-col>
              <v-col cols="12" md="12">
                <v-divider class="pa-0 ma-0 mb-2"></v-divider>
              </v-col>

              <div
                class="col-md-12"
                style="display: flex; justify-content: right; margin-top: 8px"
              >
                <v-btn
                  depressed
                  color="primary"
                  min-width="170px"
                  class="me-5 text-capitalize"
                  @click="onSubmitFor()"
                >
                  Save
                </v-btn>

                <v-btn
                  depressed
                  color="primary"
                  class="text-capitalize"
                  outlined
                  min-width="170px"
                  @click="closeDialog()"
                >
                  <v-icon small class="me-2">mdi-close-circle-outline</v-icon
                  >Cancel
                </v-btn>
              </div>
            </v-row>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-dialog persistent v-model="dialog" width="500">
        <v-card>
          <v-toolbar color="secondary" dark flat dense>
            <span> Kyc Status</span>
            <v-spacer></v-spacer>
            <v-btn depressed icon @click="closeStatus()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="mt-2">
            <v-form v-model="valid" ref="UserListtatus">
              <v-row no-gutters class="d-block">
                <v-col cols="12" md="12">
                  <label class="my-0 rounded required"> Kyc Status </label>
                  <v-select
                    :items="items"
                    class="rounded"
                    :rules="FieldRequired('Kyc Status')"
                    v-model="kyc_status"
                    placeholder="Select Kyc Status"
                    dense
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
              <v-row no-gutters class="d-block">
                <v-col cols="12" md="12">
                  <label class="my-0 rounded required">Select Remarks </label>
                  <v-select
                    v-model="selectedReamarks"
                    :items="
                      kyc_status === 'Rejected'
                        ? kycRejectedRemarks
                        : kycApprovedRemarks
                    "
                    placeholder="Select Remarks"
                    :rules="FieldRequired('Remarks')"
                    class="rounded"
                    dense
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
              <v-row
                no-gutters
                class="d-block"
                v-if="selectedReamarks === 'Others'"
              >
                <v-col cols="12" md="12">
                  <label class="my-0 rounded required">Other Remarks </label>
                  <v-textarea
                    placeholder="Enter Other Remarks"
                    :rules="FieldRequired('Other Remarks')"
                    class="rounded"
                    dense
                    outlined
                    required
                    v-model="remarks"
                  ></v-textarea> </v-col
                >kycstatus
              </v-row>
            </v-form>
          </v-card-text>

          <v-divider class="mb-0"></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              outlined
              small
              color="primary"
              @click="closeStatus()"
              ><v-icon small class="me-2">mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn small depressed color="primary" @click="kycstatus()">
              Submit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <image-viewer
      :showDialog="isImageViewer"
      :picture="{
        PicHeight: '435',
        PicWidth: 600,
        Pic: imageViewerUrl,
      }"
      @closeImageViewer="handleCloseImageViewer"
    ></image-viewer>
    <OverlayPageVue :showOverlay="loader" />
  </v-section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import imageViewer from "@/utils/imageViewer.vue";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import setupService from "@/services/SetupService/setupService";
import userService from "@/services/UserService/userService.js";
import { findDatePrevious } from "@/utils/helper";
import { BusUserTypes } from "@/utils/BusDocuments";
import { FieldRequired } from "@/utils/validation.js";
import { filterNumberInput } from "@/utils/contactNumber/formatNumber.js";
import businessService from "@/services/BusinessService/businessService";
import commonService from "@/services/CommonService/commonService.js";
import { isMykadIdType } from "@/utils/isMykadIdType.js";
import alerts from "@/mixins/alerts";
import handleImageUpload from "@/mixins/compressImage.mixin";
export default {
  // props: ["BusKYCData"],
  mixins: [alerts, handleImageUpload],
  data() {
    return {
      FieldRequired,
      filterNumberInput,
      expanded: [],
      isImageViewer: false,
      imageViewerUrl: "",
      kyc_status: "",
      kycApprovedRemarks: [],
      selectedReamarks: "",
      kycRejectedRemarks: [],
      remarks: "",
      dob: null,
      loader: false,
      headers: [
        {
          text: "Full Name",
          align: "start",
          sortable: false,
          value: "full_name",
        },
        { text: "ID type", value: "id_type.value" },
        { text: "ID number", value: "id_number" },
        { text: "First page", value: "id_first_page" },
        { text: "Last page", value: "id_last_page" },
        { text: "Selfie", value: "applicant_selfy" },
        { text: "KYC Status", value: "kyc_status" },
        { text: "Action", value: "actions" },
        { text: "", value: "data-table-expand" },
      ],
      BusKYCData: [],
      BusDialog: false,
      valid: true,
      selctedEntity: "Private Limited Companies (Sdn Bhd)",
      buscheckboxes: BusUserTypes(),
      Entitycheckbox: [],
      validationFields: [],
      backPageUrl: null,
      frontPageUrl: null,
      dialogDelete: false,
      dialog: false,
      dobmenu: false,
      maxDate: "",
      minDate: "",
      isDobError: false,
      isValidNumber: false,
      country_options: [],
      Occupation: [],
      IDTypes: [],
      DOBErrors: [],
      fileRules: [],
      items: [
        { text: "Approved", value: "Approved" },
        { text: "Rejected", value: "Rejected" },
      ],
      genderOptions: [
        { text: "Male", value: "M" },
        { text: "Female", value: "F" },
      ],
      countrySelected: {},
      KYCStatus: [
        { text: "Rejected", value: "R" },
        { text: "Approved", value: "A" },
      ],
      editedItem: {
        biz_user_id: null,
        id_first_page: "",
        id_last_page: "",
        full_name: "",
        nationality_code: "",
        country_code: "",
        gender: "",
        id_type_code: "",
        id_number: "",
        dob: "",
        type: "",
        address: "",
        phone_number: "",
        email_id: "",
        occupation_code: "",
        employer: "",
        percentage_of_shares: 0,
        no_of_shares: 0,
        id_issue_date: "",
        id_expiry_date: "",
        id_issue_country: "",
      },
    };
  },
  name: "",
  components: {
    // VuePhoneNumberInput,
    OverlayPageVue,
    imageViewer,
  },

  computed: {
    isMykad() {
      return isMykadIdType(this.editedItem.id_type_code, this.IDTypes);
    },
    DOBerrors() {
      const errors = [];
      if (!this.$v.editedItem.applicant_date_of_birth.$dirty) return errors;
      !this.$v.editedItem.applicant_date_of_birth.required &&
        errors.push(this.$t("select_dob"));
      if (this.isDobError) {
        errors.push(this.$t("invalid_dob"));
      }
      return errors;
    },
  },

  watch: {
    isMykad(value) {
      if (value) {
        this.editedItem.id_issue_date = null;
        this.editedItem.id_expiry_date = null;
      }
    },
  },
  created() {},
  mounted() {
    this.getRemarksDropdown("KSAR");
    this.getRemarksDropdown("KSRR");
    this.maxDate = findDatePrevious(new Date(), 18);
    this.minDate = findDatePrevious(new Date(), 70);
    this.getBusinessKYC();
    this.getCountryList();
    this.getOccupation();
    this.getIdTypes();
  },

  methods: {
    isMykadIdType,
    handleCloseImageViewer() {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = "";
    },
    handleImageViewer(url) {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = url;
    },

    handleFileUpload(data, page) {
      console.log("image data", data);
      if (data && page == "lastpage") {
        this.editedItem.id_last_page = URL.createObjectURL(data);
      }
      if (data && page == "firstpage") {
        this.editedItem.id_first_page = URL.createObjectURL(data);
      }
      if (data.type.startsWith("image/")) {
        this.fileRules = [];
      } else {
        this.fileRules.push("Invalid image type.");
      }
    },
    async getRemarksDropdown(code) {
      try {
        const responseData = await commonService.getparameterdropdowns(code);
        if (responseData.data.status_code === 200) {
          if (code === "KSAR") {
            this.kycApprovedRemarks = responseData.data.data.map((i) => {
              return i.value;
            });
          } else if (code == "KSRR") {
            this.kycRejectedRemarks = responseData.data.data.map((i) => {
              return i.value;
            });
          }
        }
        console.log("docs_LIST", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getBusinessKYC() {
      this.loader = true;
      try {
        const responseData = await businessService.getapplicantInfo(
          this.$route.query.id,
        );
        if (responseData.data.status_code === 200) {
          this.BusKYCData = responseData.data.data;
          this.loader = false;
        } else {
          this.showAlertError(responseData.data.message);
          this.loader = false;
        }
        console.log(this.BusKYCData, "BUS KYC Details");
      } catch (e) {
        console.error(e);
        this.loader = false;
        this.showAlertError("Failed : Something Went Wrong");
      }
    },
    closeStatus() {
      this.dialog = false;
      this.$refs.UserListtatus.resetValidation();
    },
    getColor(kyc_status) {
      console.log("kyc_status", kyc_status);
      if (kyc_status === "Approved") return "green";
      else return "orange";
    },
    updateStatus(item) {
      console.log(item);
      this.dialog = true;
      console.log(this.$route.query.customerid);
      this.kyc_status = item.kyc_status ? item.kyc_status : null;
    },

    closeDialog() {
      this.BusDialog = false;
      this.$refs.Addform.resetValidation();
    },

    editData(item) {
      this.BusDialog = true;
      this.editedItem.biz_user_id = item.biz_user_id;
      this.editedItem.email_id = item.email_id;
      this.editedItem.full_name = item.full_name;
      this.editedItem.gender = item.gender;
      this.editedItem.address = item.address;
      this.editedItem.dob = item.dob;
      this.editedItem.id_issue_date = item.id_issue_date;
      this.editedItem.id_number = item.id_number;
      this.editedItem.id_expiry_date = item.id_expiry_date;
      this.editedItem.nationality_code =
        item.nationality && item.nationality.iso_alpha3;
      this.editedItem.id_issue_country = item.id_issue_country;
      this.editedItem.country_code = item.country && item.country.iso_alpha3;
      this.editedItem.occupation_code =
        item.occupation && item.occupation.value_code;
      this.editedItem.id_type_code = item.id_type && item.id_type.value_code;
      this.editedItem.id_last_page = item.id_last_page;
      this.editedItem.id_first_page = item.id_first_page;
      console.log(this.editedItem);
    },

    onSubmitFor() {
      const validate = this.$refs.Addform.validate();
      if (validate) {
        this.update();
      }
    },

    async update() {
      this.loader = true;
      try {
        const responseData = await businessService.updateKYCDetails(
          {
            biz_user_id: this.editedItem.biz_user_id,
            customer_id: this.$route.query.customerid,
          },
          this.editedItem,
        );
        if (responseData.data.status_code === 200) {
          this.showAlertSuccess(responseData.data.message);
          this.getBusinessKYC();
          this.BusDialog = false;
          this.loader = false;
        } else {
          this.showAlertError(responseData.data.message);
          this.loader = false;
        }
        console.log(responseData);
      } catch (e) {
        console.error(e);
        this.loader = false;
        this.showAlertError("Failed : Something Went Wrong");
      }
    },

    open() {
      this.$refs.selfiefile.$el.querySelector("input").click();
    },
    openIdlast() {
      this.$refs.idlastfile.$el.querySelector("input").click();
    },
    openIdfirst() {
      this.$refs.idfirstfile.$el.querySelector("input").click();
    },
    ValidateAge(value) {
      if (!value) this.isDobError = false;
      else this.isDobError = !(value <= this.maxDate && value >= this.minDate);
    },
    onChangeNumber(e) {
      this.isValidNumber = e.isValid;
    },
    onClickBack() {
      this.$emit("onClickBack");
    },
    onClickNext() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.$emit("onNextClick", this.editedItem);
    },
    async getCountryList() {
      try {
        const response = await setupService.getCountrysetupList();
        if (response.status === 200) {
          this.country_options = response.data.data.map((i) => {
            return { text: i.name, value: i.iso_alpha3 };
          });
        }

        console.log("countrys", response);
      } catch (e) {
        console.error(e);
        this.country_options = [];
      }
    },
    async getOccupation() {
      this.loader = true;
      const code = "OCC";
      try {
        const responseData = await commonService.getparameterdropdowns(code);
        if (responseData && responseData.data.status_code === 200) {
          this.Occupation = responseData.data.data.map((i) => {
            return {
              text: i.value,
              value: i.value_code,
            };
          });
          this.loader = false;
        } else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
        }
        console.log("idList", responseData);
      } catch (e) {
        this.loader = false;
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
      }
    },
    async getIdTypes() {
      this.loader = true;
      const code = "DOC";
      try {
        const responseData = await commonService.getparameterdropdowns(code);
        if (responseData && responseData.data.status_code === 200) {
          this.IDTypes = responseData.data.data.map((i) => {
            return {
              text: i.value,
              value: i.value_code,
            };
          });
          this.loader = false;
        } else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
        }
        console.log("idList", responseData);
      } catch (e) {
        this.loader = false;
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
      }
    },

    async kycstatus() {
      const validate = this.$refs.UserListtatus.validate();
      if (validate === true) {
        const remarks =
          this.selectedReamarks === "Others"
            ? this.remarks
            : this.selectedReamarks;
        this.loader = true;
        try {
          const responseData = await userService.prfileKYCstatus(
            this.$route.query.id,
            this.kyc_status,
            remarks,
          );
          if (responseData.data.status_code === 200) {
            this.showAlertSuccess(responseData.data.message);
            this.getBusinessKYC();
            this.loader = true;
            this.dialog = false;
          } else {
            this.showAlertError(responseData.data.message);
            this.loader = false;
          }

          console.log(responseData);
        } catch (e) {
          console.error(e);
          this.loader = false;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";

.title-lbl {
  width: 100%;
  padding: 5px;
  text-align: center;
  font-weight: bold;
  color: $txt;
  border-bottom: 1px solid $txt;
}

.menu-sec {
  margin-top: 0.5rem;
  text-align: left;
  .v-list-item {
    min-height: 36px;
    label {
      width: 50%;
    }
  }
}
.required:after {
  content: " *";
  color: red;
}
</style>
